import { Text, TEXT_SIZES } from "@puregym/ui";
import { useGymSearchState } from "../../../context";
import { getPluralLabel } from "../../../utilities/helpers";
import labels from "../../labels";

const SearchHint = (props) => {
  const { filteredGyms } = useGymSearchState();

  const gymsFound = getPluralLabel(
    labels.gymFinder.searchCount,
    filteredGyms.length,
    new Map([["resultCount", filteredGyms.length]])
  );

  return (
    <Text as="span" role="alert" size={TEXT_SIZES.MEDIUM} {...props}>
      {gymsFound}
    </Text>
  );
};

export default SearchHint;
